import { useState } from 'react';
import { getTagsToLeads } from '../../helpers/leads.api';
import toaster from '../../../../shared/toaster';
import { ResponseErrorWithHandled } from '../../../../shared/types';

export const useLeadApiState = () => {
  const [leadTags, setLeadTags] = useState([]);
  const [isLeadTagsLoading, setIsLeadTagsLoading] = useState(false);

  const fetchLeadTags = async (applyLoading = false) => {
    try {
      if (applyLoading) {
        setIsLeadTagsLoading(true);
      }
      const response = await getTagsToLeads();
      const data = response.payload || [];
      setLeadTags(data);
    } catch (error) {
      if (!(error as ResponseErrorWithHandled).isHandled) {
        toaster.error(
          (error as ResponseErrorWithHandled).message || 'Error fetching tags',
        );
      }
    } finally {
      if (applyLoading) {
        setIsLeadTagsLoading(false);
      }
    }
  };

  return {
    leadTags,
    setLeadTags,
    isLeadTagsLoading,
    fetchLeadTags,
  };
};
